import type { Questionnaire, QuestionnaireResponse } from '@medplum/fhirtypes';
import {
  isMinorCustodyConsentScreeningQuestionnaire,
  validateMinorCustodyConsentScreeningResponse,
} from '@/schemas/minor-custody-consent-screening.schema';
import type { QuestionnaireFillValidationResult } from './questionnaireResponseFillValidation';

export type TemplateFormValidationOptions = {
  scopeLinkIds?: ReadonlySet<string>;
};

/**
 * Run template-specific Zod validation after generic required-field checks pass.
 */
export function validateTemplateSpecificFormFields(
  questionnaire: Questionnaire,
  response: Pick<QuestionnaireResponse, 'item'>,
  options?: TemplateFormValidationOptions,
): QuestionnaireFillValidationResult {
  if (isMinorCustodyConsentScreeningQuestionnaire(questionnaire)) {
    return validateMinorCustodyConsentScreeningResponse(response, options);
  }
  return { success: true };
}
